<div class="user-step">

  <div class="ui form questions-area">

    <div class="question" *ngFor="let question of questions">

      <div class="question-text">{{ question.question }}</div>

      <div *ngIf="question.format == 'checkbox' || question.format == 'radio' ">

        <table class="ui table celled answer-table">
          <tr class="header-row">
            <td>Selected</td>
            <td>No selected</td>
          </tr>
          <tr>
            <td>
              <div *ngFor="let answerOption of question.answerOptions">
                <span *ngIf="answerOption.isSelected">{{answerOption.description}}</span>
              </div>
            </td>
            <td>
              <div *ngFor="let answerOption of question.answerOptions">
                <span *ngIf="!answerOption.isSelected">{{answerOption.description}}</span>
              </div>
            </td>
          </tr>
        </table>

      </div>

      <div *ngIf="question.format == 'opentext'">
        <div *ngIf="question.openTextAnswer">{{question.openTextAnswer}}</div>
        <div *ngIf="!question.openTextAnswer">You did not answer this question.</div>
      </div>

    </div>



  </div>


</div>
